module.exports = __webpack_public_path__ + "img/frame (188).5e06e765.jpg";